/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-console */
import {useNavigate} from 'react-router-dom';
// eslint-disable-next-line import/named
import {confirmAlert} from 'react-confirm-alert';
import {toast} from 'react-toastify';
import ReactPaginate from 'react-paginate';

import type {ISubscriberProfile, User} from 'interfaces';
import {useDeleteUserMutation} from 'services';
import type {TData} from './Users';

import 'react-confirm-alert/src/react-confirm-alert.css';

type TProps = {
	dataUsers: ISubscriberProfile | null | any;
	refetch: () => Promise<void>;
	isDisabled: boolean;
	pageCount: number;
	onPageClick: (selected: TData) => void;
};
const TableUsers = ({
	dataUsers,
	refetch,
	isDisabled,
	pageCount,
	onPageClick,
}: TProps) => {
	const navigate = useNavigate();

	// api
	const [deleteUser] = useDeleteUserMutation();

	/**
	 * It returns an object with the properties that the modal component needs to render
	 * @param {ISubscriberProfile} item - ISubscriberProfile - The item that is being passed to the modal.
	 */
	const optionsRemoveModal = (item: User) => ({
		title: 'Do you really want to remove this user?',
		message: 'This action can not be undone.',
		buttons: [
			{
				label: 'Yes',
				// eslint-disable-next-line @typescript-eslint/require-await
				onClick: async () => {
					try {
						void deleteUser(item.username);
						await refetch();
						toast.success('Deleted User Successfully!');
					} catch (error) {
						console.error(error);
					}
				},
			},
			{
				label: 'No',
			},
		],
		closeOnEscape: true,
		closeOnClickOutside: true,
		keyCodeForClose: [8, 32],
		overlayClassName: 'overlay-custom-class-name',
	});

	const handleRemove = (item: User) => confirmAlert(optionsRemoveModal(item));

	return (
		<div className="panel-body">
			<div className="col-md-12 mt-4 ">
				{' '}
				<div className="table-responsive h500 mt-2">
					<table className="table table-striped table-sm table-head-fixed text-nowrap">
						<thead>
							<tr>
								<th className="col-1">Username</th>
								<th className="col-1">E-mail</th>
								<th className="col-3">Name</th>
								<th className="col-1">Surname</th>
								<th className="col-1">List of active roles</th>
								{!isDisabled && <th className="col-1">Actions</th>}
							</tr>
						</thead>
						<tbody>
							{dataUsers ? (
								dataUsers.map((item: User, key: number) => (
									<tr key={key}>
										<td>{item.username}</td>
										<td>{item.email}</td>
										<td>{item.name}</td>
										<td>{item.surname}</td>
										<td>{JSON.stringify(item?.permissions)}</td>
										{!isDisabled && (
											<td>
												<button
													className="border-0 bg-transparent d-inline"
													onClick={() =>
														navigate(`/users/edit/${item.username}`, {
															state: item,
														})
													}>
													<i
														className="bi-1 bi-pencil"
														title="Edit"
														data-toggle="tooltip"
													/>
												</button>

												<button
													className="border-0 bg-transparent d-inline"
													onClick={() => handleRemove(item)}>
													<i
														className="bi-1 bi-trash-fill text-danger"
														title=""
														data-toggle="tooltip"
														data-original-title="Delete"
													/>
												</button>
											</td>
										)}
									</tr>
								))
							) : (
								<div className="text-center">
									<span className="h6">No data</span>
								</div>
							)}
						</tbody>
					</table>
				</div>
			</div>

			<ReactPaginate
				previousLabel="Previous"
				nextLabel="Next"
				breakLabel="..."
				pageCount={pageCount}
				marginPagesDisplayed={2}
				pageRangeDisplayed={2}
				onPageChange={onPageClick as never}
				containerClassName="pagination justify-content-center"
				pageClassName="page-item"
				pageLinkClassName="page-link"
				previousClassName="page-item"
				previousLinkClassName="page-link"
				nextClassName="page-item"
				nextLinkClassName="page-link"
				breakClassName="page-item"
				breakLinkClassName="page-link"
				activeClassName="active"
			/>
		</div>
	);
};

export default TableUsers;
